import { render, staticRenderFns } from "./automaticServerNew.vue?vue&type=template&id=14a94d3a&scoped=true&"
import script from "./automaticServerNew.vue?vue&type=script&lang=js&"
export * from "./automaticServerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a94d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a94d3a')) {
      api.createRecord('14a94d3a', component.options)
    } else {
      api.reload('14a94d3a', component.options)
    }
    module.hot.accept("./automaticServerNew.vue?vue&type=template&id=14a94d3a&scoped=true&", function () {
      api.rerender('14a94d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/automaticServer/automaticServerNew.vue"
export default component.exports